/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-lonely-if */
import React, { FC, useState, useEffect } from 'react';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import NoTitular from './NoTitular';
import Cotitular from './Cotitular';
import Titular from './Titular';
import TitularTpec from './TitularTpec';
import TitularOroTpec from './TitularOroTpec';
import TitularOro from './TitularOro';
import CotitularTpec from './CotitularTpec';
import { TarjetaService } from '../../services';
import { StorageHelper } from '../../utils/StorageHelper';
import { CryptoUtil } from '../../utils/CryptoUtil';
import { useAuthStore } from '../../store/AuthContext';
import NotFound from '../NotFound';
import { GtmConstants } from '../../utils/GtmConstants';
import useDatalayerEvents from '../../hooks/useDatalayerEvents';
import { CookieHelper } from '../../utils/CookieHelper';
import BotonVolverFlotante from '../../components/BotonVolverFlotante';
import { BackMappings } from '../../utils/BackMappings';
import useAPIError from '../../hooks/useAPIError';
import { SessionChecker } from '../../utils/SessionChecker';

const TarjetasEroski: FC = () => {
  const dataUser = useAuthStore();
  const [tipoUsuarioTarjeta, setTipoUsuarioTarjeta] = useState<number>(-1);
  const { addError } = useAPIError();
  const { t } = useTranslation();
  const TIPOTARJETA_NO_TITULAR = 0;
  const TIPOTARJETA_TITULAR = 1;
  const TIPOTARJETA_TITULAR_Y_TPEC = 3;
  const TIPOTARJETA_TITULAR_Y_ORO = 4;
  const TIPOTARJETA_TITULAR_Y_ORO_Y_TPEC = 5;
  const TIPOTARJETA_COTITULAR = 6;
  const TIPOTARJETA_COTITULAR_Y_TPEC = 7;
  const retrieveTipoUsuarioTarjeta = () => {
    if (StorageHelper.isTipoTarjetaUsuarioInSession()) {
      const tipoSession = CryptoUtil.decrypt(
        sessionStorage.getItem('tipoUsuarioTarjeta') as string,
      );
      setTipoUsuarioTarjeta(Number(tipoSession));
    } else {
      TarjetaService.getTipoUsuarioTarjeta().then((response) => {
        if (response.data.errorCode === BackMappings.GO_TO_RELOGIN) {
          SessionChecker.closeSessionAndGoToReLogin(
            BackMappings.TARJETA,
            i18n.language,
          );
        }
        if (response.data.error !== true) {
          if (tipoUsuarioTarjeta < 0) {
            setTipoUsuarioTarjeta(response.data);
          } else {
            sessionStorage.setItem(
              'tipoUsuarioTarjeta',
              CryptoUtil.encrypt(response.data.toString()),
            );
          }
        }
      });
    }
  };

  useEffect(() => {
    if (tipoUsuarioTarjeta < 0) {
      retrieveTipoUsuarioTarjeta();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipoUsuarioTarjeta]);

  useEffect(() => {
    if (dataUser.user.token !== '' && tipoUsuarioTarjeta < 0) {
      retrieveTipoUsuarioTarjeta();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser.user.token]);

  useDatalayerEvents(GtmConstants.MI_CUENTA);

  return (
    <>
      <BotonVolverFlotante />
      {(() => {
        if (CookieHelper.isBloqueada()) {
          return (
            <>
              <NotFound />
            </>
          );
        }
        if (dataUser.user.isEmpresa && !dataUser.user.titular) {
          return (
            <>
              <NotFound />
            </>
          );
        }

        if (StorageHelper.isForzeSinTarjetas()) {
          return (
            <>
              <NoTitular />
            </>
          );
        }
        if (tipoUsuarioTarjeta === TIPOTARJETA_NO_TITULAR) {
          return (
            <>
              <NoTitular />
            </>
          );
        }
        if (tipoUsuarioTarjeta === TIPOTARJETA_TITULAR) {
          return (
            <>
              <Titular />
            </>
          );
        }
        if (tipoUsuarioTarjeta === TIPOTARJETA_TITULAR_Y_TPEC) {
          return (
            <>
              <TitularTpec />
            </>
          );
        }
        if (tipoUsuarioTarjeta === TIPOTARJETA_TITULAR_Y_ORO) {
          return (
            <>
              <TitularOro />
            </>
          );
        }
        if (tipoUsuarioTarjeta === TIPOTARJETA_TITULAR_Y_ORO_Y_TPEC) {
          return (
            <>
              <TitularOroTpec />
            </>
          );
        }
        if (tipoUsuarioTarjeta === TIPOTARJETA_COTITULAR) {
          return (
            <>
              <Cotitular />
            </>
          );
        }
        if (tipoUsuarioTarjeta === TIPOTARJETA_COTITULAR_Y_TPEC) {
          return (
            <>
              <CotitularTpec />
            </>
          );
        }

        return <></>;
      })()}
    </>
  );
};
export default TarjetasEroski;
